// Aggregator: all UK trade calculators, split by section under ./calc/.
// Each calculator object is byte-identical to the original; logic lives per-section.

import { BRICKLAYERS } from './calc/bricklayers.mjs';
import { GROUNDWORKERS } from './calc/groundworkers.mjs';
import { DRAINAGE } from './calc/drainage.mjs';
import { MUCKAWAY } from './calc/muckaway.mjs';
import { BUSINESS } from './calc/business.mjs';
import { PLASTERERS } from './calc/plasterers.mjs';
import { PAINTERS } from './calc/painters.mjs';
import { TILERS } from './calc/tilers.mjs';
import { ROOFERS } from './calc/roofers.mjs';
import { CARPENTERS } from './calc/carpenters.mjs';
import { PLUMBERS } from './calc/plumbers.mjs';
import { ELECTRICIANS } from './calc/electricians.mjs';
import { KITCHEN } from './calc/kitchen.mjs';
import { GENERAL } from './calc/general.mjs';
import { GARDENERS } from './calc/gardeners.mjs';

export const CALCULATORS = [
  ...BRICKLAYERS,
  ...GROUNDWORKERS,
  ...DRAINAGE,
  ...MUCKAWAY,
  ...BUSINESS,
  ...PLASTERERS,
  ...PAINTERS,
  ...TILERS,
  ...ROOFERS,
  ...CARPENTERS,
  ...PLUMBERS,
  ...ELECTRICIANS,
  ...KITCHEN,
  ...GENERAL,
  ...GARDENERS,
];

export const TRADES = [
  { slug: 'general-builders', name: 'General Builders', tagline: 'Job-wide estimating', icon: 'HardHat' },
  { slug: 'groundworkers', name: 'Groundworkers & Landscapers', tagline: 'Foundations, paving, decking, sleeper walls, muck away', icon: 'Shovel' },
  { slug: 'drainage', name: 'Drainage', tagline: 'Falls, gradients, soakaways, French drains', icon: 'Droplets' },
  { slug: 'bricklayers', name: 'Bricklayers', tagline: 'Bricks, blocks, mortar', icon: 'BrickWall' },
  { slug: 'kitchen-fitters', name: 'Kitchen Fitters', tagline: 'Worktops, units, plinths', icon: 'UtensilsCrossed' },
  { slug: 'plumbers', name: 'Plumbers', tagline: 'Boilers, rads, pipework', icon: 'Wrench' },
  { slug: 'electricians', name: 'Electricians', tagline: 'Circuits, lighting, cabling', icon: 'Zap' },
  { slug: 'plasterers', name: 'Plasterers', tagline: 'Skim, bonding, boarding', icon: 'PaintRoller' },
  { slug: 'painters', name: 'Painters & Decorators', tagline: 'Coverage, wallpaper', icon: 'Paintbrush' },
  { slug: 'carpenters', name: 'Carpenters', tagline: 'Studs, joists, rafters', icon: 'Hammer' },
  { slug: 'roofers', name: 'Roofers', tagline: 'Tiles, felt, battens', icon: 'Home' },
  { slug: 'tilers', name: 'Tilers', tagline: 'Tiles, adhesive, grout', icon: 'Grid3x3' },
  { slug: 'gardeners', name: 'Gardeners & Landscapers', tagline: 'Planting, seed, compost, mulch, irrigation, lawn care', icon: 'Sprout' },
  { slug: 'business-essentials', name: 'Business Essentials', tagline: 'Overheads, VAT, markup, day rate', icon: 'Briefcase' },
];

export const calcsForTrade = (slug) => CALCULATORS.filter((c) => c.trade === slug);
